<template>
  <!-- main area -->
  <div class="centerArea_wrapper">
    <Conference :conference="hall" :is-room="true" />
  </div>
</template>

<script>
import Conference from "../modules/Conference"

export default {
  name: "HRoom",
  components: {Conference},
  props: {
    hallSlug: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    hall() {
      return this.$store.getters["hall/getBySlug"](this.hallSlug)
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    handleResize() {
      if (window.innerWidth <= 992) {
        this.$store.commit("sideMenu/collapseByLeft", false)
        this.$store.commit("sideMenu/collapseByRight", false)
      } else {
        return
      }
    }
  }
}
</script>
